import "./works.css";
import "./mediaMobile.css";
import { Link } from "react-router-dom";
import { AI_PROJECTS, RepoCard } from "./aiProjects";

export default function Works() {
  return (
    <section className="section workWrap">
      <h3 className="sec-label">Work</h3>
      <p className="sec-statement">
        Selected projects — <span className="mute">AI systems built to solve real problems</span>, from idea to deployment.
      </p>

      <h4 className="workSubhead">AI &amp; Machine Learning</h4>
      <div className="repoGrid">
        {AI_PROJECTS.map((p) => <RepoCard key={p.title} p={p} />)}
      </div>

      <Link to="/wwork" className="archiveLink">
        <span>
          <span className="archiveLinkLabel">See all my work</span>
          <span className="archiveLinkSub">AI projects, the design &amp; web archive, case studies &amp; gallery</span>
        </span>
        <span className="arw">↗</span>
      </Link>
    </section>
  );
}
